import "owl.carousel";

const templateHome = {
  init: function () {
    this.banner_slider();
  },

  banner_slider: function () {
    var slider = $(".banner__slider");

    $("body").on("click", ".banner__dot", function (e) {
      if ($(window).width() > 660) {
        e.preventDefault();
        var index = $(this).attr("data-slide");
        slider.trigger("to.owl.carousel", index);
      }
    });

    function sync(index) {
      $(".banner__dot").removeClass("banner__dot-current");
      $(".banner__dot").eq(index).addClass("banner__dot-current");
    }

    slider.on("initialized.owl.carousel", function () {
      $(".banner__dot").eq(0).addClass("banner__dot-current");
    });

    slider.owlCarousel({
      slideSpeed: 500,
      paginationSpeed: 500,
      responsiveRefreshRate: 50,
      items: 1,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      freeDrag: false,
      animateOut: "fadeOut",
      animateIn: false,

      nav: true,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="9.866" height="16" viewBox="0 0 9.866 16"><path d="M1.867,0,0,1.867,6.133,8,0,14.133,1.867,16l8-8Z" transform="translate(9.867 16) rotate(180)"/></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="9.866" height="16" viewBox="0 0 9.866 16"><path d="M1.867,0,0,1.867,6.133,8,0,14.133,1.867,16l8-8Z"/></svg>',
      ],
      navContainer: ".banner__nav",
    });

    slider.on("changed.owl.carousel", function (ev) {
      sync(ev.item.index);
    });
  },
};

export default templateHome;
